import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

const GraphicsPageRelatedItem = ({ publishDate, title, url }) => {
  const { trackEvent } = useEventTracking();

  return (
    <li className="border-0 border-b border-solid border-grayscale-gray py-24 last:border-b-0">
      <a
        href={url}
        onClickCapture={() =>
          trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title, clickLink: url }))
        }
        className="my-8 font-suisse-neue text-body-lg text-black hover:text-primary-magenta dark:hover:text-primary-pink"
      >
        {title}
      </a>
      {publishDate && (
        <time
          className="block font-suisse-screen text-disclosure-sm text-grayscale-charcoal"
          title={publishDate}
          dateTime={publishDate}
        >
          {publishDate}
        </time>
      )}
    </li>
  );
};

export default GraphicsPageRelatedItem;
